import { cn } from '@ahm/common-helpers';

interface ProgressRingProps {
  progress: number;
  isGenerating: boolean;
}

export function ProgressRing({ progress, isGenerating }: ProgressRingProps) {
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="relative size-[120px] rounded-full overflow-hidden">
      <div className="glass-bg" />
      <div className="gradient-bg" />
      <div className="inner-shadow" />

      <svg
        className="absolute inset-0 size-full -rotate-90"
        viewBox="0 0 120 120"
      >
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke="url(#bgGradient)"
          strokeWidth="8"
          opacity="0.3"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke="url(#progressGradient)"
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className={cn(
            'transition-all duration-300 ease-out',
            isGenerating ? 'progress-glow-active' : 'progress-glow'
          )}
        />
        <circle
          cx="60"
          cy="15"
          r="4"
          fill="#ff8200"
          className="animate-pulse"
          style={{
            transformOrigin: '60px 60px',
            transform: `rotate(${(progress / 100) * 360}deg)`,
          }}
        />
        <defs>
          <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0.05" />
          </linearGradient>
          <linearGradient
            id="progressGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#ff8200" />
            <stop offset="50%" stopColor="#ffa040" />
            <stop offset="100%" stopColor="#ff8200" />
          </linearGradient>
        </defs>
      </svg>

      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="ai-planner-button px-2 rounded-full mb-1">
          <span className="text-white text-xs font-semibold tracking-wide p-0.5">
            AI học
          </span>
        </div>

        <div className="relative">
          <span
            className={cn(
              'text-2xl font-bold gradient-text',
              isGenerating && 'shimmer-text'
            )}
          >
            {progress}%
          </span>

          {isGenerating && (
            <>
              <span className="sparkle sparkle-1">✨</span>
              {/* <span className="sparkle sparkle-2">⭐</span> */}
            </>
          )}
        </div>

        {isGenerating && (
          <div className="absolute -bottom-8 flex items-center gap-1">
            <div className="dot-bounce" />
            <div className="dot-bounce" style={{ animationDelay: '0.1s' }} />
            <div className="dot-bounce" style={{ animationDelay: '0.2s' }} />
          </div>
        )}
      </div>
    </div>
  );
}
